import React from "react";

import Banner from "./Banner";
import Features from "./Features";
import Explain from "./Explain";
import Contact from "../../common/Contact";

const ApplicationHome = () => {
  return (
    <div>
      <Banner />
      <Features />
      <Explain />
      <Contact />
    </div>
  );
};

export default ApplicationHome;
